<template>
  <div class="tender-contractors">
    <div class="tender-contractors__row tender-contractors__header">
      <div class="tender-contractors__cell tender-contractors__cell_header">
        {{ $t('Company') }}
      </div>
      <div class="tender-contractors__cell tender-contractors__cell_header">
        {{ $t('Currency') }}
      </div>
      <div class="tender-contractors__cell tender-contractors__cell_header">
        {{ $t('Members') }}
      </div>
      <div class="tender-contractors__cell tender-contractors__cell_header" />
    </div>
    <div v-for="(contractor, idx) in contractors" :key="idx" class="tender-contractors__row">
      <div class="tender-contractors__cell">
        <div v-if="contractor.contractor_team">
          {{ contractor.contractor_team.name }}
        </div>
        <Badge
          v-if="contractor.status"
          class="tender-status ml-auto"
          :color="TENDER_OFFER_STATUS_BADGE[contractor.status] || 'green'"
          contrast
        >
          <span class="capitalize">{{
            get(contractor, 'versions.length')
              ? $tc('offer', contractor.versions.length)
              : contractor.status
          }}</span>
        </Badge>
        <Badge v-else class="tender-status ml-auto" color="light-blue" contrast>
          <span class="capitalize">{{ $t('New') }}</span>
        </Badge>
      </div>
      <div class="tender-contractors__cell">
        {{ currencyWithSymbol(contractor.currency) }}
      </div>
      <div class="tender-contractors__cell">
        <ContractorContactsList :contacts="contractor.contractor_responsible_users" />
      </div>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div class="tender-contractors__cell" v-bind="attrs" v-on="on">
            <Icon type="more-horizontal" size="20" />
          </div>
        </template>
        <DropdownMenu>
          <DropdownMenuElement left-icon="trash" @click.native="$emit('delete', idx)">
            {{ $t('Delete') }}
          </DropdownMenuElement>
        </DropdownMenu>
      </v-menu>
    </div>
  </div>
</template>

<script>
  import { VMenu } from 'vuetify/lib';
  import CloseIcon from '@/assets/icons/x.svg';
  import EditIcon from '@/assets/icons/pencil.svg';
  import Badge from '@/components/ui/Badge';
  import { mapGetters } from 'vuex';
  import Icon from '@/components/ui/Icon';
  import DropdownMenu from '@/components/ui/dropdown-menu/DropdownMenu';
  import DropdownMenuElement from '@/components/ui/dropdown-menu/DropdownMenuElement';
  import get from 'lodash.get';
  import ContractorContactsList from '@/containers/tenders/create/tender-contractors/ContractorContactsList';
  import TENDER_OFFER_STATUS_BADGE from '@/utils/constants/tender-offer-status-badge';

  export default {
    name: 'TenderContractors',
    components: {
      ContractorContactsList,
      DropdownMenuElement,
      DropdownMenu,
      Icon,
      Badge,
      VMenu,
    },
    props: {
      contractors: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        closeIcon: CloseIcon,
        editIcon: EditIcon,
        TENDER_OFFER_STATUS_BADGE,
      };
    },
    computed: {
      ...mapGetters('global', ['currencyWithSymbol']),
    },
    methods: {
      get,
      getUsersForShow(idx) {
        return this.contractors?.[idx]?.contractor_responsible_users?.slice(0, 4) || [];
      },
    },
  };
</script>

<style lang="scss">
  @import 'src/styles/components/tender-contractors';
</style>
